/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_Site_Thigh_RightInputs */

const en_us2_body_measures_site_thigh_right = /** @type {(inputs: Body_Measures_Site_Thigh_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right thigh`)
};

const pt_br2_body_measures_site_thigh_right = /** @type {(inputs: Body_Measures_Site_Thigh_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coxa dir.`)
};

const es_419_body_measures_site_thigh_right = /** @type {(inputs: Body_Measures_Site_Thigh_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muslo der.`)
};

const pt_pt2_body_measures_site_thigh_right = /** @type {(inputs: Body_Measures_Site_Thigh_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coxa dir.`)
};

const fr_fr2_body_measures_site_thigh_right = /** @type {(inputs: Body_Measures_Site_Thigh_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuisse droite`)
};

const de_de2_body_measures_site_thigh_right = /** @type {(inputs: Body_Measures_Site_Thigh_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oberschenkel re.`)
};

const it_it2_body_measures_site_thigh_right = /** @type {(inputs: Body_Measures_Site_Thigh_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coscia dx`)
};

/**
* | output |
* | --- |
* | "Right thigh" |
*
* @param {Body_Measures_Site_Thigh_RightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_site_thigh_right = /** @type {((inputs?: Body_Measures_Site_Thigh_RightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Site_Thigh_RightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_site_thigh_right(inputs)
	if (locale === "es-419") return es_419_body_measures_site_thigh_right(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_site_thigh_right(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_site_thigh_right(inputs)
	if (locale === "de-DE") return de_de2_body_measures_site_thigh_right(inputs)
	if (locale === "it-IT") return it_it2_body_measures_site_thigh_right(inputs)
	return en_us2_body_measures_site_thigh_right(inputs)
});
export { body_measures_site_thigh_right as "body-measures.site_thigh_right" }